import { h, Fragment } from 'preact'
import PropTypes from 'prop-types'
import { useState } from 'preact/compat'
import ArrowDownIcon from '../../../assets/dynamicIcons/ArrowIcon'
import { isMobile } from '../../../helpers/common'
import './styles.scss'

const childPositionMap = {
  top: 'top',
  bottom: 'bottom',
}

const ShowMore = ({
  children,
  visibleLabelText,
  hiddenLabelText,
  showInMobile = true,
  color,
  childrenPosition = childPositionMap.top,
  ...props
}) => {
  if (showInMobile && !isMobile()) {
    return children
  }

  const [isContentVisible, setIsContentVisible] = useState(false)
  const handleClick = () => setIsContentVisible(!isContentVisible)
  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleClick()
    }
  }

  return isContentVisible ? (
    <>
      {childPositionMap.top === childrenPosition && children}
      <div
        className="show-more-label"
        onClick={handleClick}
        onKeyPress={handleKeyDown}
        tabIndex="0"
        {...props}
      >
        {hiddenLabelText}
        <ArrowDownIcon color={color} isTop />
      </div>
      {childPositionMap.bottom === childrenPosition && children}
    </>
  ) : (
    <div
      className="show-more-label"
      onClick={handleClick}
      onKeyPress={handleKeyDown}
      tabIndex="0"
      {...props}
    >
      {visibleLabelText}
      <ArrowDownIcon color={color} />
    </div>
  )
}

ShowMore.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  visibleLabelText: PropTypes.string.isRequired,
  hiddenLabelText: PropTypes.string.isRequired,
  showInMobile: PropTypes.bool,
  childrenPosition: PropTypes.oneOf([...Object.values(childPositionMap)]),
}

export default ShowMore
